{
  "EMOJI": {
    "PLACEHOLDER": "Ieškoti emodžių",
    "NOT_FOUND": "Jūsų paieška neatitinka jokių emodži",
    "REMOVE": "Pašalinti"
  }
}
